import { inject, provideLazy } from '@/diagnostic/injections.ts';
import { DIAGNOSE_DIAGNOSTIC, DIAGNOSTICS, RULES_REPOSITORY } from '@/diagnostic/DiagnosticKeys.ts';
import { DiagnoseDiagnostic } from '@/diagnostic/domain/DiagnoseDiagnostic.ts';
import { key, piqure } from 'piqure';
import { type AuthenticatedFetcher, buildFetcher } from '@/generic/authentication';
import { initRule } from '@/rule';
import { RulesRepositoryRule } from '@/diagnostic/secondary/RulesRepositoryRule.ts';
import { config } from '@/config';
import { CleanApiDiagnosticsHttp } from '@/diagnostic/secondary/CleanApiDiagnosticsHttp.ts';

export const PROVIDE_DIAGNOSTIC = Symbol('Provide diagnostic');

const FETCHER = key<AuthenticatedFetcher>('Diagnostic fetcher');

const local = piqure();

export const provideDiagnostic = () => {
  const { injectRulesRepository } = initRule();
  local.provideLazy(FETCHER, () => buildFetcher());

  provideLazy(
    DIAGNOSTICS,
    () => new CleanApiDiagnosticsHttp(local.inject(FETCHER), config().pollingDuration),
  );
  provideLazy(DIAGNOSE_DIAGNOSTIC, () => new DiagnoseDiagnostic(inject(DIAGNOSTICS)));
  provideLazy(RULES_REPOSITORY, () => new RulesRepositoryRule(injectRulesRepository()));
};
